import { render, staticRenderFns } from "./StudentHeader.vue?vue&type=template&id=c57ab720&scoped=true&"
import script from "./StudentHeader.vue?vue&type=script&lang=js&"
export * from "./StudentHeader.vue?vue&type=script&lang=js&"
import style0 from "./StudentHeader.vue?vue&type=style&index=0&id=c57ab720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57ab720",
  null
  
)

export default component.exports